"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTypeParameterMeta = void 0;
var metadata_handler_1 = require("./metadata-handler");
var service_identifier_1 = require("../instantiation/service-identifier");
var error_messages_1 = require("../constants/error-messages");
/**
 * 构造函数参数装饰器，给类的构造函数添加元数据
 * @param metadataKey
 * @param annotationTarget
 * @param propertyName
 * @param newMetaId
 * @param parameterIndex
 */
function addTypeParameterMeta(metadataKey, annotationTarget, propertyName, newMetaId, parameterIndex) {
    // propertyName不为undefined表示为普通函数参数装饰器，暂时不支持
    if (propertyName !== undefined && typeof parameterIndex === 'number') {
        throw new Error(error_messages_1.INVALID_DECORATOR_OPERATION);
    }
    // 装饰器修饰的构造函数参数下标
    var position = parameterIndex.toString();
    // 获取target上的metadata
    var targetMetadata = metadata_handler_1.MetadataHandler.getDepsMetadata(metadataKey, annotationTarget) || {};
    // 判断是否有对应属性index的metadata
    var positionMetadata = targetMetadata[position];
    // 注入不同的identifier则抛出异常
    if ((positionMetadata === null || positionMetadata === void 0 ? void 0 : positionMetadata[0]) !== undefined && (positionMetadata === null || positionMetadata === void 0 ? void 0 : positionMetadata[0]) !== newMetaId) {
        // eslint-disable-next-line new-cap
        throw new Error(error_messages_1.DUPLICATED_PARAMETER_METADATA(annotationTarget.name, position, service_identifier_1.getIdentifierName(positionMetadata[0]), service_identifier_1.getIdentifierName(newMetaId)));
    }
    // 更新meta信息
    if (positionMetadata && positionMetadata[1] && !positionMetadata[1].serviceIdentifier) {
        // 可能提前设置了meta的其他属性
        positionMetadata[0] = newMetaId;
        positionMetadata[1].serviceIdentifier = newMetaId;
    }
    else if (positionMetadata === undefined) {
        // 新建meta信息
        targetMetadata[position] = [
            newMetaId,
            {
                serviceIdentifier: newMetaId,
            }
        ];
        metadata_handler_1.MetadataHandler.setDepsMetadata(metadataKey, targetMetadata, annotationTarget);
    }
}
exports.addTypeParameterMeta = addTypeParameterMeta;
//# sourceMappingURL=add-parameter-meta.js.map